import { defineComponent as _defineComponent } from 'vue'
import Form from '@/resources/exercises/Form.vue';
import { Exercise, UnknownExercise } from '@ilteducation/exercise-service-types';

type Props = {
  id: string;
  title: string;
  item: Exercise | UnknownExercise;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: null,
    title: null,
    item: null
  },
  setup(__props: any) {



return { __sfc: true,Form }
}

})